import { render, staticRenderFns } from "./GeneralAndSpecialistDoctors.vue?vue&type=template&id=59778829&scoped=true&"
import script from "./GeneralAndSpecialistDoctors.vue?vue&type=script&lang=js&"
export * from "./GeneralAndSpecialistDoctors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59778829",
  null
  
)

export default component.exports